import { BigNumber } from '@ethersproject/bignumber';
import { getLixiBagContract } from '@web3react';

export async function getGlobalWinningTicket() {
  const contract = getLixiBagContract();
  const ticketId = (await contract.getGlobalWinningTicket()) as BigNumber;
  return ticketId.toNumber();
}
